<template>
    <modal ref="modal" noWrapper>
      <div id="sub-wrapper">
        <div>
          <loaderAnimation></loaderAnimation>
          <div>{{ $t('modals.call_room_session.text1') }}</div>
        </div>
        <div>{{ $t('modals.call_room_session.text2') }}</div>
      </div>
    </modal>
</template>

<script>
export default {
  methods: {
    show () {
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  align-items: center;
  background-color: #323232;
  border-radius: 1em;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2.5em 4em;
}

#sub-wrapper > div:first-child {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 2em;
}

#sub-wrapper #loader-animation {
  font-size: 2em;
  margin-right: 1em;
}

</style>
